import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AppTitleService {

  titleSignal = signal<string>('');
  
  constructor() {}

  setTitle(title: string) {
    this.titleSignal.set(title);
  }  
}
